import * as React from 'react';

/**
 * Put this component inside the form to submit form when user hits "enter" key.
 */
const HiddenSubmit = () => <input tabIndex={-1} type="submit" hidden />;

export default HiddenSubmit;
